import React, {Component} from 'react'
import {UserAction} from '../actions/UserAction'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {gaPageView} from "../constants";
import {RedocStandalone} from 'redoc';
import apiDoc from '../api-doc.json'
import $ from 'jquery'

class ApiDoc extends Component {

    componentDidMount() {
        gaPageView()
    }

    redocLoaded() {
        $(function () {
            $('a[href*="Redocly/redoc"]').parent().remove()
        })
    }

    render() {

        function recreateApiDoc(apiDoc) {

            // apiDoc.info["x-logo"] = {
            //     "url": "https://searchsanctions.com/assets/img/logo/logo.png",
            //     "href": "https://kurumsal.searchsanctions.com/console",
            //     "altText": "search sanctions api doc logo",
            //     "backgroundColor": "linear-gradient(118deg, #084f79 0%, #00a99d 100%)",
            //     "padding": "41px 13px",
            //     "gutter": "13px"
            // };

            apiDoc.servers = [
                {
                    "url": "https://api.searchsanctions.com",
                    "description": "The enterprise live domain"
                },
                {
                    "url": "https://sandboxapi.searchsanctions.com",
                    "description": "The enterprise test domain"
                }
            ]

            return apiDoc;
        }

        let apiDocConf = recreateApiDoc(apiDoc)

        let options = {
            disableSearch: true,
            nativeScrollbars: true,
            jsonSampleExpandLevel: "all",
            theme: {
                colors: {
                    primary: {
                        main: '#204f79'
                    }
                }
            },
        };

        return (
            <>
                <RedocStandalone
                    specUrl={apiDocConf}
                    options={options}
                    onLoaded={this.redocLoaded()}
                />
            </>
        )
    }

}

function mapStateToProps(state) {
    return {
        common: state.common,
        user: state.user
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        userAction: UserAction
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ApiDoc);